import React, { Component } from "react";
import "./DateInput.less";

class DateInput extends Component {
  render() {
    const { label, name, value, onChange, required = false, error } = this.props;

    return (
      <div className="date-input">
        <label htmlFor={name} className={required ? "required" : ""}>
          {required && <span className="date-input__required">*</span>} {label}
        </label>
        <div className="date-input__wrapper">
          <input
            name={name}
            type="date"
            value={value}
            onChange={onChange}
            className={error ? "date-input__error" : ""}
          />
        </div>
        {error && <p className="date-input__error-message">{error}</p>}
      </div>
    );
  }
}

export default DateInput;